import { PACKAGE_TYPES_MAP_V2 } from "../../../constants/seller-package-constants";
import { CAR_HEALTH_INFO } from "./constant";

export const getCarHealthDetails = (details = []) => {
    const res = [];
    details.forEach(({feature, rating}) => {
        if (CAR_HEALTH_INFO[feature]) {
            res.push({
                ...CAR_HEALTH_INFO[feature],
                rating
            });
        }
    });
    return res;
};

export const getHeaderText = (carDetails) => {
    const {
        year = "",
        make: makeName = "",
        model: modelName = ""
    } = carDetails || {};

    if (carDetails) return `${year ? year : ""} ${makeName ? makeName : ""} ${modelName ? modelName : ""} `;
    return "";
};

export const getCmsSlugForSellerPackage = (type) => {
    if (type === PACKAGE_TYPES_MAP_V2.SELL_PRO) {
        return "seller-package-sold-pro-widget";
    } else if (type === PACKAGE_TYPES_MAP_V2.SELL_LITE) {
        return "seller-package-sold-lite-widget";
    }
    return "i2p-seller-package-sell-card";
};
